import { getState } from 'lib/store'
import type {
  Attribute,
  AttributeTreeNode,
  AttributeValueCount,
} from 'types/search/attributes'

/**
 * Get raw attributes from API
 */
export const getAttributes = (): Attribute[] =>
  getState().search.attributes.attributes

/**
 * Get tree-structured attributes for Tree component
 */
export const getAttributesTree = (): AttributeTreeNode[] =>
  getState().search.attributes.treeData

/**
 * Check if attributes are being fetched
 */
export const isFetchingAttributes = (): boolean =>
  getState().search.attributes.isFetching

/**
 * Get attribute values with count
 */
export const getAttributeValues = (): AttributeValueCount[] =>
  getState().search.attributes.attributeValues

/**
 * Check if attribute values are being fetched
 */
export const isFetchingAttributeValues = (): boolean =>
  getState().search.attributes.isFetchingValues
